import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../constants/environment';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  setItem(key: string, value: any): void {
    try {
      const serialized = JSON.stringify(value);
      localStorage.setItem(key, serialized);
    } catch (error) {
      console.error('Error saving to localStorage', error);
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error reading from localStorage', error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage', error);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage', error);
    }
  }

  hasSeenOnboarding(): boolean {
    return this.getItem<boolean>(STORAGE_KEYS.SEEN_ONBOARDING) === true;
  }

  setSeenOnboarding(seen: boolean): void {
    this.setItem(STORAGE_KEYS.SEEN_ONBOARDING, seen);
  }

  getLanguage(): string | null {
    return this.getItem<string>(STORAGE_KEYS.LANGUAGE);
  }

  setLanguage(lang: string): void {
    this.setItem(STORAGE_KEYS.LANGUAGE, lang);
  }

  getHash(): string | null {
    return this.getItem<string>(STORAGE_KEYS.HASH);
  }

  setHash(hash: string): void {
    this.setItem(STORAGE_KEYS.HASH, hash);
  }

  getForReview(): boolean | null {
    return this.getItem<boolean>(STORAGE_KEYS.REVIEW);
  }

  setForReview(forreview: boolean): void {
    this.setItem(STORAGE_KEYS.REVIEW, forreview);
  }

  getTreatment(): any {
    return this.getItem(STORAGE_KEYS.PATIENT_TREATMENT);
  }

  setTreatment(treatment: any): void {
    this.setItem(STORAGE_KEYS.PATIENT_TREATMENT, treatment);
  }

  clearTreatment(): void {
    this.removeItem(STORAGE_KEYS.PATIENT_TREATMENT);
  }
}
